export enum IntermediarioEnum {
  SOCIETA_QUOTATE = 'SOCIETA_QUOTATE',
  POSTE_ITALIANE = 'POSTE_ITALIANE',
  CASSA_DEPOSITI = 'CASSA_DEPOSITI',
  PUBBLICA_AMMINISTRAZIONE = 'PUBBLICA_AMMINISTRAZIONE',
  ISTITUZIONE_ORGANISMO = 'ISTITUZIONE_ORGANISMO',
  BANCA = 'BANCA',
  IMEL = 'IMEL',
  IP = 'IP',
  SIM = 'SIM',
  SGR = 'SGR',
  SICAV = 'SICAV',
  SICAF = 'SICAF',
  TUB_106 = 'TUB_106',
  IMPRESA_ASSICURAZIONE = 'IMPRESA_ASSICURAZIONE',
  TUB_111 = 'TUB_111',
  TUB_112 = 'TUB_112',
  INTERMEDIARIO_ESTERO = 'INTERMEDIARIO_ESTERO',
  SUCCURSALE_INTERMEDIARIO = 'SUCCURSALE_INTERMEDIARIO',
  NESSUNO = 'NESSUNO',
}
